import {
  getOperationPackageInstance as getSharedOperationPackageInstance,
  postOperationPackageInstanceAbort,
} from "@/features/operation-instances/api";

export function getOperationPackageInstance(params: { instanceId: string }) {
  const { instanceId } = params;
  return getSharedOperationPackageInstance("IT_OPERATION_CORE", instanceId);
}

export function abortInstance(params: { instanceId: string }) {
  const { instanceId } = params;
  return postOperationPackageInstanceAbort("IT_OPERATION_CORE", instanceId);
}
